module.exports = __webpack_public_path__ + "img/1489118155.d0ba096e.jpg";